import React from 'react'
import { CardFrame } from '../../../ui/CardFrame/CardFrame.jsx'
import { FeedbackDirectionToggle } from '../interactions/FeedbackDirectionToggle.jsx'
import { ToggleChip } from '../../../ui/ToggleChip/ToggleChip.jsx'
import { migrateFeedbackDirectionData } from '../interactions/feedbackDirectionMigration.js'

/**
 * FeedbackCard — give/receive toggle + context textarea + tag chips.
 * catalog #11, prep-feedback. Extends FeedbackDirectionToggle with tags.
 */

const TAG_OPTIONS = [
  { id: 'behaviour',     label: 'behaviour' },
  { id: 'craft',         label: 'craft' },
  { id: 'communication', label: 'communication' },
  { id: 'delivery',      label: 'delivery' },
  { id: 'collaboration', label: 'collaboration' },
]

export function FeedbackCard({ card, value, onChange, disabled }) {
  const migrated = migrateFeedbackDirectionData(value)
  const tags = value?.tags ?? []

  function handleToggleChange(next) {
    onChange({ ...next, tags })
  }

  function toggleTag(id) {
    if (disabled) return
    const next = tags.includes(id) ? tags.filter((t) => t !== id) : [...tags, id]
    onChange({ ...migrated, tags: next })
  }

  const hasFill = migrated?.direction || tags.length > 0

  return (
    <CardFrame
      kind="prep"
      icon="⇄"
      iconClass="clay"
      title="Feedback"
      prompt="What feedback do you want to give or receive?"
      state={disabled ? 'locked' : hasFill ? 'filled' : 'empty'}
      data-testid="prep-card-prep-feedback"
      className="prepcard"
    >
      <FeedbackDirectionToggle
        value={migrated}
        onChange={handleToggleChange}
        disabled={disabled}
        maxContextChars={200}
      />
      {migrated?.direction && (
        <div style={styles.tags}>
          <span style={styles.tagsLabel}>Tags</span>
          <div style={styles.chipRow} role="group" aria-label="Feedback tags">
            {TAG_OPTIONS.map((opt) => (
              <ToggleChip
                key={opt.id}
                selected={tags.includes(opt.id)}
                disabled={disabled}
                onClick={() => toggleTag(opt.id)}
              >
                {opt.label}
              </ToggleChip>
            ))}
          </div>
        </div>
      )}
    </CardFrame>
  )
}

const styles = {
  tags: { padding: '0 14px 12px', display: 'flex', flexDirection: 'column', gap: 6 },
  tagsLabel: { fontSize: 10, fontFamily: 'var(--font-mono)', fontWeight: 700, color: 'var(--color-text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em' },
  chipRow: { display: 'flex', flexWrap: 'wrap', gap: 6 },
}
